import React from 'react';
import styles from './UserManagement.module.css';

const UserCard = ({ user, onDetail, onEdit, onPermission, onDelete, selected, onSelect }) => {
  const getRoleBadgeClass = (role) => {
    switch (role) {
      case 'admin':
        return styles.adminBadge;
      case 'superuser':
        return styles.superuserBadge;
      default:
        return styles.userBadge;
    }
  };

  const getStatusBadgeClass = (status) => {
    return status === 'active' ? styles.activeBadge : styles.inactiveBadge;
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(user.id);
  };

  // Avatar helper
  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ').map(part => part[0]).join('').toUpperCase().slice(0,2);
  };

  return (
    <div className={styles.userCard}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <input
          type="checkbox"
          checked={selected}
          onChange={onSelect}
          style={{ marginRight: '0.5rem' }}
        />
        {/* Avatar */}
        {user.avatar ? (
          <img src={user.avatar} alt="avatar" className={styles.avatar} />
        ) : (
          <div className={styles.avatarPlaceholder}>{getInitials(user.name)}</div>
        )}
        <div className={styles.userInfo} style={{ flex: 1 }}>
          <div className={styles.userHeader}>
            <h3 className={styles.userName}>{user.name}</h3>
            <span className={`${styles.badge} ${getRoleBadgeClass(user.role)}`}>
              {user.role === 'admin' ? 'Admin' : 
               user.role === 'superuser' ? 'Süper Kullanıcı' : 
               'Normal Kullanıcı'}
            </span>
          </div>
          {/* Etiketler */}
          {user.tags && user.tags.length > 0 && (
            <div className={styles.userTags} style={{ margin: '0.5rem 0' }}>
              {user.tags.map((tag, idx) => (
                <span key={idx} className={styles.userTag}>{tag}</span>
              ))}
            </div>
          )}
          <p className={styles.userEmail}>{user.email}</p>
          <div className={styles.userMeta}>
            <span className={`${styles.badge} ${getStatusBadgeClass(user.status)}`}>
              {user.status === 'active' ? 'Aktif' : 'Pasif'}
            </span>
            <span className={styles.department}>
              {user.department}
            </span>
          </div>
          <div className={styles.userDetails}>
            <span className={styles.lastLogin}>
              <i className="fas fa-clock"></i> Son giriş: {user.lastLogin}
            </span>
            <span className={styles.createdAt}>
              <i className="fas fa-calendar"></i> Oluşturulma: {user.createdAt}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.userActions}>
        <button
          className={`${styles.button} ${styles.detailButton}`}
          onClick={onDetail}
          title="Detayları Görüntüle"
        >
          <i className="fas fa-eye"></i>
        </button>
        <button
          className={`${styles.button} ${styles.editButton}`}
          onClick={onEdit}
          title="Düzenle"
        >
          <i className="fas fa-edit"></i>
        </button>
        <button
          className={`${styles.button} ${styles.permissionButton}`}
          onClick={onPermission}
          title="İzinleri Yönet"
        >
          <i className="fas fa-key"></i>
        </button>
        <button
          className={`${styles.button} ${styles.deleteButton}`}
          onClick={handleDelete}
          title="Sil"
        >
          <i className="fas fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default UserCard; 